// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  z-index: 1000 !important;
  width: 100%;
  background-color: transparent;
}
.search-container .searchbar-container .searchbar {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  border: solid 1px #fff;
  border-radius: 5px;
  margin: 0.25rem;
  width: auto;
}
@media (orientation: landscape) and (min-width: 768px) {
  .search-container .searchbar-container .searchbar {
    padding-left: calc(var(--sar, 0px) / 1.5);
    padding-right: calc(var(--sar, 0px) / 1.5);
  }
}
.search-container .searchbar-container .searchbar input.custom-input {
  background: none !important;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  color: #FFF;
  caret-color: #FFF;
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
}
.search-container .searchbar-container .searchbar input.custom-input::placeholder {
  color: #FFF;
}
.search-container .searchbar-container .searchbar .search-icon-container,
.search-container .searchbar-container .searchbar .close-icon-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0.5rem;
}
.search-container .searchbar-container .searchbar:focus-within, .search-container .searchbar-container .searchbar.active {
  border: solid 1px #FFF;
}
.search-container .searchbar-container .searchbar:focus-within input.custom-input, .search-container .searchbar-container .searchbar.active input.custom-input {
  color: white !important;
  caret-color: white !important;
}
.search-container .searchbar-container .searchbar:focus-within input.custom-input::placeholder, .search-container .searchbar-container .searchbar.active input.custom-input::placeholder {
  color: #FFF !important;
}
.search-container .searchbar-container .searchbar:focus-within ion-icon, .search-container .searchbar-container .searchbar.active ion-icon {
  color: white !important;
}
.search-container .keyword-container {
  position: relative;
  display: none;
  flex-direction: column;
  align-items: start;
  padding-left: 1rem;
  padding-bottom: 0.5rem;
  gap: 0.8rem;
  width: 97%;
  margin-left: 1.5%;
  padding-top: 10px;
  height: 220px;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.2);
}
@media (orientation: landscape) and (max-width: 990px) {
  .search-container .keyword-container {
    max-height: 40vh;
  }
}
.search-container .keyword-container .keyword {
  margin-top: 2px;
  cursor: pointer; /* Add cursor pointer for better UX */
  font-weight: 500; /* Medium font weight */
}
.search-container .keyword-container.show {
  display: flex;
}
.search-container .keyword-container::-webkit-scrollbar {
  display: none;
}
.search-container .games-container {
  position: absolute;
  display: flex;
  z-index: 100;
  flex-direction: column;
  margin: 0 0.45rem;
  max-height: 65vh;
  width: 97%;
  margin-left: 1.5%;
  overflow-y: scroll;
  background-color: #FFF;
  border-radius: 10px;
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.2);
}
@media (orientation: landscape) and (max-width: 990px) {
  .search-container .games-container {
    max-height: 40vh;
  }
}
.search-container .games-container .games {
  display: flex;
  align-items: center; /* Center align items vertically */
  margin-top: 5px;
  padding-left: 5%;
  cursor: pointer; /* Add cursor pointer for better UX */
}
.search-container .games-container .games ion-thumbnail {
  overflow: hidden;
  border-radius: 10px;
  min-height: 56px;
  min-width: 56px;
  margin-right: 10px; /* Space between image and label */
}
.search-container .games-container .games .game-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #333; /* Adjust text color if needed */
}
.search-container .games-container.hide {
  display: none;
}
.search-container .games-container::-webkit-scrollbar {
  display: none;
}
.search-container .games-container .games:last-child {
  margin-bottom: 5px;
}
.search-container .items-count-container {
  align-self: center;
  display: flex;
  justify-content: center; /* Center the content horizontally */
  align-items: center; /* Center the content vertically */
  min-width: 2.1rem; /* Set equal width */
  height: 2.1rem; /* Set equal height */
  border-radius: 50%; /* Make it a circle */
  z-index: 99999 !important;
  padding: 4px; /* Adjust padding as needed */
  margin-left: 0.5rem; /* Add margin if needed */
}
.search-container .items-count-container .items-count {
  font-size: 0.7rem;
  color: #FFF;
  font-weight: bold;
  text-align: center;
}
.search-container ion-icon {
  color: #FFF !important;
}

::ng-deep .highlight {
  color: var(--link-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/searchbar/searchbar.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,6BAAA;AACF;AACI;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AACN;AAAM;EATF;IAUI,yCAAA;IACA,0CAAA;EAGN;AACF;AADM;EACE,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAGR;AAFQ;EACE,WAAA;AAIV;AAAM;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAER;AACM;EACE,sBAAA;AACR;AACQ;EACE,uBAAA;EACA,6BAAA;AACV;AAAU;EACE,sBAAA;AAEZ;AAEQ;EACE,uBAAA;AAAV;AASE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EAGA,4EAAA;AATJ;AAUI;EAlBF;IAmBI,gBAAA;EAPJ;AACF;AASI;EACE,eAAA;EACA,eAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,uBAAA;AAPN;AAUI;EACE,aAAA;AARN;AAWI;EACE,aAAA;AATN;AAaE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,4EAAA;AAZJ;AAaI;EAdF;IAeI,gBAAA;EAVJ;AACF;AAYI;EACE,aAAA;EACA,mBAAA,EAAA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA,EAAA,qCAAA;AAVN;AAYM;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA,EAAA,kCAAA;AAVR;AAaM;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA,EAAA,gCAAA;AAXR;AAeI;EACE,aAAA;AAbN;AAgBI;EACE,aAAA;AAdN;AAiBI;EACE,kBAAA;AAfN;AAmBE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA,EAAA,oCAAA;EACA,mBAAA,EAAA,kCAAA;EACA,iBAAA,EAAA,oBAAA;EACA,cAAA,EAAA,qBAAA;EACA,kBAAA,EAAA,qBAAA;EACA,yBAAA;EACA,YAAA,EAAA,6BAAA;EACA,mBAAA,EAAA,yBAAA;AAjBJ;AAmBI;EACE,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAjBN;AAsBE;EACE,sBAAA;AApBJ;;AAwBA;EACE,wBAAA;AArBF","sourcesContent":[".search-container {\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n  z-index: 1000 !important;\n  width: 100%;\n  background-color: transparent;\n    .searchbar-container {\n    .searchbar {\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: row;\n      border: solid 1px #fff;\n      border-radius: 5px;\n      margin: 0.25rem;\n      width: auto;\n      @media (orientation: landscape) and (min-width: 768px) {\n        padding-left: calc(var(--sar, 0px) / 1.5);\n        padding-right: calc(var(--sar, 0px) / 1.5);\n      }\n\n      input.custom-input {\n        background: none !important;\n        outline: none !important;\n        border: none !important;\n        box-shadow: none !important;\n        color: #FFF;\n        caret-color: #FFF;\n        width: 100%;\n        padding: 0.5rem;\n        font-size: 1rem;\n        &::placeholder {\n          color: #FFF;\n        }\n      }\n\n      .search-icon-container,\n      .close-icon-container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        margin: 0 0.5rem;\n      }\n\n      &:focus-within, &.active {\n        border: solid 1px #FFF;\n\n        input.custom-input {\n          color: white !important;\n          caret-color: white !important;\n          &::placeholder {\n            color: #FFF !important;\n          }\n        }\n\n        ion-icon {\n          color: white !important;\n        }\n      }\n    }\n\n\n  }\n\n \n  .keyword-container {\n    position: relative;\n    display: none;\n    flex-direction: column;\n    align-items: start;\n    padding-left: 1rem;\n    padding-bottom: 0.5rem;\n    gap: 0.8rem;\n    width: 97%;\n    margin-left: 1.5%;\n    padding-top: 10px;\n    height: 220px;\n    overflow-y: auto;\n    background-color: #fff;\n    border-radius: 10px;\n  //  border: 0.5px solid #333;\n    //box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n    box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.2);\n    @media (orientation: landscape) and (max-width: 990px) {\n      max-height: 40vh;\n    }\n\n    .keyword {\n      margin-top: 2px;\n      cursor: pointer; /* Add cursor pointer for better UX */\n      font-weight: 500; /* Medium font weight */\n    }\n\n    &.show {\n      display: flex;\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .games-container {\n    position: absolute;\n    display: flex;\n    z-index: 100;\n    flex-direction: column;\n    margin: 0 0.45rem;\n    max-height: 65vh;\n    width: 97%;\n    margin-left: 1.5%;\n    overflow-y: scroll;\n    background-color: #FFF;\n    border-radius: 10px;\n    //border: 0.5px solid #333;\n    box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.2);\n    @media (orientation: landscape) and (max-width: 990px) {\n      max-height: 40vh;\n    }\n\n    .games {\n      display: flex;\n      align-items: center; /* Center align items vertically */\n      margin-top: 5px;\n      padding-left: 5%;\n      cursor: pointer; /* Add cursor pointer for better UX */\n\n      ion-thumbnail {\n        overflow: hidden;\n        border-radius: 10px;\n        min-height: 56px;\n        min-width: 56px;\n        margin-right: 10px; /* Space between image and label */\n      }\n\n      .game-label {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        color: #333; /* Adjust text color if needed */\n      }\n    }\n\n    &.hide {\n      display: none;\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .games:last-child {\n      margin-bottom: 5px;\n    }\n  }\n\n  .items-count-container {\n    align-self: center;\n    display: flex;\n    justify-content: center;  /* Center the content horizontally */\n    align-items: center;       /* Center the content vertically */\n    min-width: 2.1rem;               /* Set equal width */\n    height: 2.1rem;              /* Set equal height */\n    border-radius: 50%;        /* Make it a circle */\n    z-index: 99999 !important;\n    padding: 4px;              /* Adjust padding as needed */\n    margin-left: 0.5rem;       /* Add margin if needed */\n  \n    .items-count {\n      font-size: 0.7rem;\n      color: #FFF;\n      font-weight: bold;\n      text-align: center;\n    }\n  }\n  \n\n  ion-icon {\n    color: #FFF !important;\n  }\n}\n\n::ng-deep .highlight {\n  color: var(--link-color);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
